import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fe9127e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9127e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe9127e2')) {
      api.createRecord('fe9127e2', component.options)
    } else {
      api.reload('fe9127e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fe9127e2&scoped=true", function () {
      api.rerender('fe9127e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1V2/page/Somos1V2ConfigurationPage/index.vue"
export default component.exports